var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtractorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_1001_10021)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6499 13.9112C27.8721 13.8083 28.1282 13.8083 28.3504 13.9112L36.6837 17.7708C36.9783 17.9072 37.1668 18.2023 37.1668 18.527V28.1761C37.1668 28.4735 37.0084 28.7483 36.751 28.8973L28.4177 33.7218C28.1594 33.8714 27.8409 33.8714 27.5826 33.7218L19.2493 28.8973C18.992 28.7483 18.8335 28.4735 18.8335 28.1761V18.527C18.8335 18.2023 19.022 17.9072 19.3166 17.7708L27.6499 13.9112ZM20.5002 19.8774L27.1668 23.2225V31.5553L20.5002 27.6956V19.8774ZM28.8335 31.5553L35.5002 27.6956V19.8774L28.8335 23.2225V31.5553ZM28.0002 21.7759L34.4155 18.557L28.0002 15.5857L21.5849 18.557L28.0002 21.7759Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 36.334C28.4604 36.334 28.8335 36.7071 28.8335 37.1673V42.1673C28.8335 42.6276 28.4604 43.0007 28.0002 43.0007C27.5399 43.0007 27.1668 42.6276 27.1668 42.1673V37.1673C27.1668 36.7071 27.5399 36.334 28.0002 36.334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5002 32.1673C20.9604 32.1673 21.3335 32.5404 21.3335 33.0007V38.0007C21.3335 38.4609 20.9604 38.834 20.5002 38.834C20.0399 38.834 19.6668 38.4609 19.6668 38.0007V33.0007C19.6668 32.5404 20.0399 32.1673 20.5002 32.1673Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5002 32.1673C35.9604 32.1673 36.3335 32.5404 36.3335 33.0007V39.6673C36.3335 40.1276 35.9604 40.5007 35.5002 40.5007C35.0399 40.5007 34.6668 40.1276 34.6668 39.6673V33.0007C34.6668 32.5404 35.0399 32.1673 35.5002 32.1673Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_10021",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractorLogo);
export default __webpack_public_path__ + "static/media/extractor-logo.f5980ef62b0a91fb2a723156ad6bcdb5.svg";
export { ForwardRef as ReactComponent };